module.exports = __webpack_public_path__ + "static/media/it-extra-large.29dcd863.svg";